<div fxLayout="row" fxLayoutAlign="center" class="mt-2">
  <div fxFlex="100" fxFlex.gt-sm="1 1 400px" fxFlex.sm="1 1 400px" class="mat-elevation-z6">

    <div fxLayout="row" fxLayoutAlign="end" class="p-3">
      <button mat-stroked-button class="m-1" (click)="back()">
        <mat-icon matSuffix class="mat-icon-rtl-mirror">navigate_before</mat-icon>
        {{ 'FUTURE-VISITS.BACK' | translate}}
      </button>
    </div>
    <div>
      <mat-error *ngIf="error" class="alert alert-danger mt-1">{{ error }}</mat-error>
    </div>

    <div fxLayout="row" fxLayoutAlign="center" class="mt-2">
      <div class="container" fxFlex>
        <div *ngFor="let currentItem of freeTimeGroupList">
          <div fxLayout="column" class="w-100 itemContainer p-3">
            <div fxLayout="row" fxLayoutAlign="space-between stretch" class="h-100">
              <div fxLayout="column" fxFlex='35%'>
                <div>{{ currentItem.SchedulerName }}</div>
                <div>
                  <span>{{ currentItem.Date | amDateFormat:'L' }}</span>
                  <span class="m-1">|</span>
                  <span>{{ currentItem.Date | amDateFormat:'ddd' }}</span>
                </div>
              </div>
              <div fxLayout="column" fxFlex='40%'>
                <div fxLayoutAlign="end">
                  <span class="startTime">{{ currentItem.StartTime}}</span>
                </div>
                <div fxLayoutAlign="end" *ngIf="currentItem.AdditionalSlots > 0">
                  <span class="additionalSlots">{{ 'FIND-TIME.CLOSE-AVAILABLE-TIME' | translate }}</span>
                  <span class="additionalSlots accent">{{currentItem.AdditionalSlots }}+</span>
                </div>
              </div>
              <div fxFlex fxLayoutAlign='end' class="p-1">
                <button mat-icon-button (click)="onSelect(currentItem)">
                  <mat-icon color="primary" class="mat-icon-rtl-mirror md-48">navigate_next</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>


        <div *ngIf="!freeTimeGroupList || freeTimeGroupList.length === 0">
          <div class="p-3 w-100" fxLayout="column" fxLayoutAlign="center center">
            <span class="accent p-3">{{ 'FIND-TIME.NO-AVAILABLE-TIME-FOUND' | translate }}</span>
            <button mat-stroked-button color="primary" class="m-3" (click)="onAddToStandby()">{{ 'FIND-TIME.ADD-TO-STANDBY' | translate}}</button>
          </div>          
        </div>
      </div>
    </div>
  </div>
</div>